// Pure logic behind the header balances strip — the port of the flash half of
// src/user/modules/layout_elements/balances.jsx (`setBalancesClasses` / `resetClassesTimeout`).
//
// Every websocket balance frame replaces the whole list, so a credit or a debit is only visible as
// a difference against the previous frame. React tagged each changed row with a colour + arrow
// class and cleared them 4 s later; the same signal is computed here as data, so the shell only has
// to render it.

// How long a changed row stays highlighted (React's setTimeout(…, 4000)).
export const BALANCE_FLASH_MS = 4000;

// Returns `{ [asset]: "up" | "down" }` for the assets whose amount moved between the two frames.
// Assets that are new in `next` are NOT flashed: React compared against a previous entry and left
// the class null when there was none, so the first frame after connecting never lights up.
export const balanceChanges = (previous, next) => {
  const before = new Map((previous ?? []).map((entry) => [entry.asset, Number(entry.balance)]));
  const changes = {};
  for (const entry of next ?? []) {
    const was = before.get(entry.asset);
    if (was === undefined || Number.isNaN(was)) continue;
    const now = Number(entry.balance);
    if (Number.isNaN(now) || now === was) continue;
    changes[entry.asset] = now > was ? "up" : "down";
  }
  return changes;
};
